// import axios from "axios"
import axios from "../../../constants/axios"
import { navigate } from "gatsby"

import endpoints from "../../../constants/endpoints"

export const CANDIDATE_SOCIAL_DATA_FETCH = async (
  id,
  dispatch,
  setSocial,
  setLoading
) => {
  try {
    const response = await axios.get(
      process.env.GATSBY_BASE_URL +
        endpoints.CANDIDATE_PROFILE_PERSONAL_ROUTE +
        id
    )
    const { data } = response
    const social_data = JSON.parse(data.personal.social)
    if (social_data) {
      setSocial(social_data)
    } else {
      setSocial([])
    }

    setLoading(false)
  } catch (err) {
    setLoading(false)
  }
}

export const SOCIAL_FORM_SUBMIT = async (
  socialFormData,
  setError,
  setAddSocial,
  setIsLoading,
  social,
  setSocial
) => {
  const fd = new FormData()
  fd.append("url", socialFormData?.url)
  try {
    await axios.patch(
      process.env.GATSBY_BASE_URL +
        endpoints.CANDIDATE_SOCIAL_SUBMIT +
        socialFormData?.site?.name +
        "/",
      fd
    )
    setSocial({ ...social, [socialFormData?.site?.name]: socialFormData?.url })
    setIsLoading(false)
    setAddSocial(false)
  } catch (error) {
    if (error.response && error.response.data) {
      setError(error.response.data)
    }
    setIsLoading(false)
  }
}

export const SOCIAL_DELETE = async (id, setShowDeleteForm, setData, data) => {
  try {
    const response = await axios.delete(
      process.env.GATSBY_BASE_URL + endpoints.CANDIDATE_SOCIAL_DELETE + id + "/"
    )
    if (response && response.status === 200) {
      delete data?.[id]
      setData(data)
      setShowDeleteForm(false)
    }
  } catch (error) {}
}

export const CANDIDATE_PROFILE_SUBMIT = async (
  setErrors,
  setLoading,
  isContinue,
  dispatch,
  path
) => {
  try {
    const res = await axios.post(
      process.env.GATSBY_BASE_URL + endpoints.CANDIDATE_PROFILE_SUBMIT
    )
    if (res.status === 200) {
      dispatch({ type: "HAS_PROFILE", payload: true })
      setErrors({ message: res.data.message })
      // setLoading(false)
      setTimeout(() => {
        // setErrors({})
        navigate(!!path ? path : "/")
      }, 2000)
    }
    if (res.status === 200 && !isContinue) {
      setErrors({ message: res.data.message })
      setLoading(false)
      setTimeout(() => {
        setErrors({})
      }, 2000)
    }
  } catch (error) {
    if (error.response && error.response.data) {
      setErrors(error.response.data)
    } else {
      setErrors({ message: "Something went wrong" })
    }
    setLoading(false)
  } finally {
    const token = localStorage.getItem("token")
    USER_DETAILS_FETCH(dispatch, token)
  }
}

export const USER_DETAILS_FETCH = async (dispatch, token) => {
  try {
    const response = await axios.get(
      process.env.GATSBY_BASE_URL + endpoints.USER_DETAIL_ROUTE
    )
    dispatch({
      type: "LOGIN",
      payload: {
        user: response.data.user,
        token: token,
      },
    })
  } catch (err) {
    dispatch({
      type: "LOGOUT",
    })
  }
}
